import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import { MessageService } from '../../../service/message/message.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
@Component({
  selector: 'app-balance-sms',
  templateUrl: './balance-sms.component.html',
  styleUrls: ['./balance-sms.component.scss']
})
export class BalanceSmsComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang = JSON.parse(<any>localStorage.getItem('lang'));
  public loading: boolean = false;
  public loading2: boolean = false;
  public subscription: Subscription | any;
  public server_main!: any;
  public server!: any;
  public user_id!: number;
  public user!: number;
  public creator!: number;
  public user_title!: string;
  public user_token!: number;
  public user_cellphone!: string;
  public Link!: string;
  public store_title!: string;
  public store_phone!: string;

  constructor(
    public serverService: ServerService,
    public dialog: MatDialog,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    public _dialogRef: MatDialogRef<BalanceSmsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any
  ) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server();
    if (dialog_data) {
      this.user = dialog_data.user;
      this.creator = dialog_data.creator;
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id
    }
    this.get_data();
  }
  get_data() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7242,
      'user': this.user,
      'creator': this.creator,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.store_title = res['result'][0].store_title;
            this.store_phone = res['result'][0].store_phone;
            this.user_token = res['result'][0].user_token;
            this.user_cellphone = res['result'][0].user_cellphone;
            this.user_title = res['result'][0].user_title;
            this.Link = this.serverService.get_my_domain() + "/balance/" + this.user + "/" + this.user_token;
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  send_sms_for_balance(): any {
    var x = confirm(this.messageService.message_sms_accept());
    if (x == false) {
      this.message(false, "", 1, this.messageService.close());
      return false;
    }
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      "address": 6921,
      "creator": this.creator,
      "userId": this.user,
      "site": this.serverService.get_my_domain()
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.serverService.send_sms_charge();
          this.message(true, this.messageService.send_message(), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          var message = "شارژ کافی برای ارسال پیامک وجود ندارد";
          this.message(true, this.messageService.message(message), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 5) {
          var message = "فرمت شماره موبایل برای ارسال درست نمی باشد";
          this.message(true, this.messageService.message(message), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 6) {
          var message = "ارسال پیامک از ساعت 21 تا ساعت 8 صبح غیر فعال می باشد";
          this.message(true, this.messageService.message(message), 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }//end if
  close() {
    this._dialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
